export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;


//AUTH
const AUTH = `/auth`;
export const API_INVITE_URL = `${AUTH}/v1/invitations`;
export const API_VALIDATE_INVITATION_URL = `${AUTH}/validate-invitation`;
export const API_ACCEPT_INVITATION_URL = `${AUTH}/accept-invitation`;
export const API_AUTH_COR_ID_GET_QR = `${AUTH}/web/initiate-login`;
export const API_AUTH_REFRESH_URI = `${AUTH}/refresh_token`;

const PROJECT = `/projects`
export const API_PROJECT_CREATE_URL = `${PROJECT}/`;
export const API_PROJECT_LIST_URL = `${PROJECT}/`;
export const API_MAKE_PROJECTS_ORDER_URL = (workspaceId) => `${PROJECT}/workspace/${workspaceId}/order`;
export const API_PROJECT_WIDGETS_URL = `${PROJECT}/widgets`;
export const API_PROJECT_MY_TASKS_WIDGET_URL = `${PROJECT}/widgets/my-tasks`;
export const API_MAKE_PROJECT_GET_URL = (projectId) => `${PROJECT}/${projectId}`;
export const API_PROJECT_STATUS_PRESETS_URL = `${PROJECT}/status-presets`;
export const API_PROJECT_STATISTICS_URL = `${PROJECT}/stats/tasks-widget`;
export const API_PROJECT_WORK_SPACE_TASK_URL = `${PROJECT}/widgets/workspace-tasks`;
export const API_MAKE_PROJECT_UPDATE_URL = (projectId) => `${PROJECT}/${projectId}`;
export const API_MAKE_PROJECT_DELETE_URL = (projectId) => `${PROJECT}/${projectId}`;
export const API_MAKE_PROJECT_ARCHIVE_URL = (projectId) => `${PROJECT}/${projectId}/archive`;
export const API_MAKE_PROJECT_UNARCHIVE_URL = (projectId) => `${PROJECT}/${projectId}/unarchive`;
export const API_MAKE_PROJECT_TASKS_URL = (projectId) => `${PROJECT}/${projectId}/tasks`;
export const API_MAKE_PROJECT_TASK_STATUSES_URL = (projectId) => `${PROJECT}/${projectId}/task-statuses`;
export const API_MAKE_PROJECT_TASK_STATUS_URL = (projectId, statusId) => `${PROJECT}/${projectId}/task-statuses/${statusId}`;
export const API_MAKE_PROJECT_DOCUMENTS_URL = (projectId) => `${PROJECT}/${projectId}/documents`;
export const API_MAKE_PROJECT_DOCUMENT_URL = (projectId, documentId) => `${PROJECT}/${projectId}/documents/${documentId}`;
export const API_MAKE_PROJECT_DOCUMENT_RENAME_URL = (projectId, documentId) => `${PROJECT}/${projectId}/documents/${documentId}/rename`;
export const API_MAKE_PROJECT_DOCUMENT_DUPLICATE_URL = (projectId, documentId) => `${PROJECT}/${projectId}/documents/${documentId}/duplicate`;
export const API_MAKE_PROJECT_DOCUMENT_MOVE_URL = (projectId, documentId) => `${PROJECT}/${projectId}/documents/${documentId}/move`;
export const API_MAKE_PROJECT_DOCUMENT_ARCHIVE_URL = (projectId, documentId) => `${PROJECT}/${projectId}/documents/${documentId}/archive`;
export const API_MAKE_PROJECT_DOCUMENT_UNARCHIVE_URL = (projectId, documentId) => `${PROJECT}/${projectId}/documents/${documentId}/unarchive`;
export const API_MAKE_PROJECT_DOCUMENT_RESTORE_URL = (projectId, documentId) => `${PROJECT}/${projectId}/documents/${documentId}/restore`;

const ATTACHMENTS = `/attachments`
export const API_MAKE_ATTACHMENTS_UPLOAD_URL  = taskId =>  `${ATTACHMENTS}/task/${taskId}/upload`;
export const API_MAKE_ATTACHMENTS_LIST_URL  = taskId =>  `${ATTACHMENTS}/task/${taskId}`;
export const API_MAKE_ATTACHMENTS_DELETE_URL = attachmentId => `${ATTACHMENTS}/${attachmentId}`;
export const API_MAKE_ATTACHMENTS_SHOW_URL = attachmentId => `${ATTACHMENTS}/${attachmentId}/file-url`;

const TASKS = `/tasks`
export const API_TASKS_CREATE_URL = `${TASKS}/`;
export const API_TASKS_LIST_URL = `${TASKS}/`;
export const API_TASKS_REORDER_URL = `${TASKS}/reorder`;
export const API_TASKS_COMPLETE_CONFIRM_URL = `${TASKS}/complete/confirm`;
export const API_MAKE_TASKS_INITIATE_COMPLETE_URL = taskId => `${TASKS}/${taskId}/complete/initiate`;
export const API_MAKE_TASKS_UPDATE_URL = taskId => `${TASKS}/${taskId}`;
export const API_MAKE_TASKS_ACTIVITIES_URL = taskId => `${TASKS}/${taskId}/activities`;
export const API_MAKE_TASKS_ARCHIVE_URL = taskId => `${TASKS}/${taskId}/archive`;
export const API_MAKE_TASKS_UNARCHIVE_URL = taskId => `${TASKS}/${taskId}/unarchive`;

const COMMENTS = `/comments`
export const API_COMMENTS_CREATE_URL = `${COMMENTS}/`;
export const API_MAKE_COMMENTS_BY_TASK_URL = taskId => `${COMMENTS}/task/${taskId}`;
export const API_MAKE_COMMENT_URL = commentId => `${COMMENTS}/${commentId}`;
export const API_MAKE_COMMENT_ATTACHMENTS_URL = commentId => `${COMMENTS}/${commentId}/attachments`;
export const API_MAKE_COMMENT_LIKE_URL = commentId => `${COMMENTS}/${commentId}/like`;

const TIME_LOGS = `/time-logs`
export const API_TIME_LOGS_URL = `${TIME_LOGS}/`;
export const API_MAKE_TIME_LOG_URL = timeLogId => `${TIME_LOGS}/${timeLogId}`;
export const API_MAKE_TASK_TIME_LOGS_URL = taskId => `${TIME_LOGS}/task/${taskId}`;
export const API_MY_TIME_LOGS_URL = `${TIME_LOGS}/user/me`;

//WORKSPACES
const WORKSPACES = `/workspaces`;
export const API_WORKSPACES_URL = `${WORKSPACES}/`;

//WORKSPACE MEMBERS
const WORKSPACE_MEMBERS = `/workspace-members`;
export const API_WORKSPACE_MEMBERS_URL = `${WORKSPACE_MEMBERS}/`;
export const API_MAKE_WORKSPACE_MEMBER_URL = (memberId) => `${WORKSPACE_MEMBERS}/${memberId}`;
export const API_MAKE_WORKSPACE_MEMBERS_GET_URL = (workspaceId) => `${WORKSPACE_MEMBERS}/workspace/${workspaceId}`;
export const API_MAKE_WORKSPACE_MEMBERS_PHOTOS_URL = (workspaceId) => `${WORKSPACE_MEMBERS}/workspace/${workspaceId}/photos`;
export const API_MAKE_WORKSPACE_INVITATION_URL = (workspaceId, invitationId) => `${WORKSPACE_MEMBERS}/workspace/${workspaceId}/invitations/${invitationId}`;
export const API_MAKE_WORKSPACE_INVITATION_RESEND_URL = (workspaceId, invitationId) => `${WORKSPACE_MEMBERS}/workspace/${workspaceId}/invitations/${invitationId}/resend`;

//PROJECT MEMBERS
const PROJECT_MEMBERS = `/project-members`;
export const API_PROJECT_MEMBERS_URL = `${PROJECT_MEMBERS}/`;
export const API_MAKE_PROJECT_MEMBERS_GET_URL = (projectId) => `${PROJECT_MEMBERS}/project/${projectId}`;
export const API_MAKE_PROJECT_MEMBER_REMOVE_URL = (projectId, userId) => `${PROJECT_MEMBERS}/project/${projectId}/user/${userId}`;

//USERS
export const API_USER_LIST_URL = `/user/list`;
export const API_USER_AVATAR_URL = `/user/photo`;

//NOTIFICATIONS
const NOTIFICATIONS = `/notifications`;
export const API_NOTIFICATIONS_LIST_URL = `${NOTIFICATIONS}/all`;
export const API_NOTIFICATIONS_UNREAD_COUNT_URL = `${NOTIFICATIONS}/unread/count`;
export const API_NOTIFICATIONS_READ_ALL_URL = `${NOTIFICATIONS}/read-all`;
export const API_MAKE_NOTIFICATION_READ_URL = (notificationId) => `${NOTIFICATIONS}/${notificationId}/read`;
export const API_MAKE_NOTIFICATION_URL = (notificationId) => `${NOTIFICATIONS}/${notificationId}`;

//RBAC
export const API_RBAC_ROLES_URL = `/rbac/roles`;

//GLOBAL SEARCH
export const API_SEARCH_URL = `/search/`;

//HOME
export const HOME_PAGE_URI_CONST = `/home`;
